import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { v4 as uuidv4 } from 'uuid';

import cashIcon from '../../../../assets/images/CashIcon.svg';
import RewardTemplateDetail from '../../../../components/shared/RewardTemplateDetail/RewardTemplateDetail';
import { rewardDisplayLabel } from '../../../../helpers/currencyHelper';

import ReferralRewardHeading from './ReferralRewardHeading';

import styles from './ReferralRewardBadge.module.scss';

const ReferralRewardBadge = ({
  rewards = [],
  eligibileForRewards,
  monetaryRewardSum,
  user,
  showPublicRewards = false,
  rewardDisplayLabel: summaryDisplayLabel,
}) => {
  const { t } = useTranslation('common');
  const [isCollapsed, setIsCollapsed] = useState(
    !eligibileForRewards && !(showPublicRewards && !user),
  );

  const summaryRewardLabel = rewardDisplayLabel({
    displayLabel: summaryDisplayLabel,
    amount: monetaryRewardSum?.monetary_reward,
    currencyCode: monetaryRewardSum?.currency_id,
  });

  const handleToggleCollapse = () => {
    setIsCollapsed(!isCollapsed);
  };

  return (
    <div className={styles.mainContainer}>
      <ReferralRewardHeading
        eligibileForRewards={eligibileForRewards}
        user={user}
        isCollapsed={isCollapsed}
        onToggleCollapse={handleToggleCollapse}
        showToggleButton={!eligibileForRewards}
      />
      {!isCollapsed && (
        <div className={styles.rewardTypes}>
          {monetaryRewardSum && monetaryRewardSum.monetary_reward > 0 && (
            <RewardTemplateDetail
              icon={cashIcon}
              title={summaryRewardLabel}
              text={t('buttons.cash')}
              classname={styles.verticalLine}
            />
          )}
          {rewards.map((singleReward) =>
            singleReward.map((reward) => (
              <React.Fragment key={uuidv4()}>
                {reward?.experiential_rewards_attributes &&
                  reward?.experiential_rewards_attributes.map((exper_reward) => (
                    <RewardTemplateDetail
                      key={uuidv4()}
                      icon={exper_reward.image}
                      title={exper_reward.name}
                      text={exper_reward.description}
                      classname={styles.verticalLine}
                    />
                  ))}
              </React.Fragment>
            ))
          )}
        </div>
      )}
    </div>
  );
};

export default ReferralRewardBadge;
